<template>
  <v-card flat>
    <!-- <v-card-title style="text-align: center; justify-content: center;" v-if="!batchEditingTags && !batchEditingMaps && !$vuetify.breakpoint.mobile">
      {{$t('video.video_clips')}}
    </v-card-title> -->
    <div
      v-if="game_times && game_times.length"
      class="d-flex justify-center mb-3"
    >
      <v-btn-toggle v-model="show_own">
        <v-btn small outlined :value="true">Omat klipit</v-btn>
        <v-btn small outlined :value="false">
          ePesiksen ajat
          <v-chip class="ml-2" x-small outlined>{{ game_times ? game_times.length : 0 }}</v-chip>
        </v-btn>
      </v-btn-toggle>
    </div>
    <!-- EPESIKSEN AJAT -->
    <div class="mb-4" v-if="game_times && game_players && game_times.length && !show_own">
      <div style="font-size: 20px;">
        ePesiksen mittaamat
      </div>
      <v-btn-toggle v-if="showLentoGroup" v-model="show_lento" class="mt-2">
        <v-btn x-small outlined :value="false">Kaikki</v-btn>
        <v-btn x-small outlined :value="true">Lento</v-btn>
      </v-btn-toggle>
      <v-btn-toggle v-if="pesis_league_name === 'msu'" v-model="show_up" class="mt-2 ml-2">
        <v-btn x-small outlined :value="false">Sisäpeli</v-btn>
        <v-btn x-small outlined :value="true">Ulkopeli</v-btn>
      </v-btn-toggle>
      <div
        v-if="loading_game_times"
        class="d-flex justify-center pt-4"
      >
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="!show_up">
          <!-- ULKOPELI -->
          <div v-if="filteredEpesisTimes.length" class="mt-4">Etenemiset</div>
          <VideoTimes :times="filteredEpesisTimes" />
        </div>
        <div v-else>
          <!-- SISÄPELI -->
          <div v-if="filteredEpesisTimesUp.length" class="mt-4">Ulkopeli</div>
          <VideoTimes :times="filteredEpesisTimesUp" />
        </div>
      </div>
    </div>

    <div v-else>
      <div class="mb-4" style="font-size: 20px;">
        Omat klipit
      </div>
      <!-- SETTINGS -->
      <div v-if="!loading_video_clips" class="mb-1 d-flex justify-end">
        <v-btn
          x-small
          v-if="!selecting"
          text
          @click="filteringByTags = true"
        >
          <v-icon small class="mr-1">mdi-filter-variant</v-icon>
          Suodata
          <v-chip x-small class="ml-2">
            {{ tags.length }}
          </v-chip>
        </v-btn>
        <v-btn text x-small v-if="tags.length">
          <v-icon @click="tags = []">mdi-close</v-icon>
        </v-btn>
        <TagViewsDialog
          :show="filteringByTags"
          @set="filteringByTags = false"
          @close="filteringByTags = false"
          v-model="tags"
        ></TagViewsDialog>

        <v-btn
          v-if="currentTeamId"
          class="ml-2"
          x-small
          text
          @click="select"
        >
        <v-icon small class="mr-1 ml-1">mdi-check</v-icon>
          {{ selecting ? $t('cancel') : $t('analysis.select')}}
        </v-btn>
        <v-btn
          v-if="selecting"
          class="ml-1"
          x-small
          @click="handleBatchDelete"
        >
          {{ $t('delete') }}
          <v-icon class="ml-1" small>mdi-delete</v-icon>
        </v-btn>
        <v-btn
          v-if="selecting"
          class="ml-1"
          x-small
          @click="handleBatchFolder"
        >
          {{$t('analysis.add_to_folder')}}
          <v-icon class="ml-1" small>mdi-folder-outline</v-icon>
      </v-btn>
      <div v-if="!$vuetify.breakpoint.mobile" style="display: inline">
        <label v-if="selecting" for="selectall" class="ml-3"> {{ $t('analysis.select_all')}} </label>
        <input v-if="selecting" id="selectall" type="checkbox" class="ml-0 mr-0" v-model="allSelected" @input="selectAll"/>
      </div>
      <div v-else style="display: inline">
        <label v-if="selecting" for="selectall" class="ml-3"> {{ $t('analysis.select_all_short')}} </label>
        <input v-if="selecting" id="selectall" type="checkbox" class="ml-0 mr-0" v-model="allSelected" @input="selectAll"/>
      </div>
      </div>
      <div v-if="loading_video_clips" class="d-flex justify-center">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
      <div v-else :class="`${$vuetify.breakpoint.mobile ? 'clips-mobile' : 'clips'} pa-1`">
        <div>
          <TimeItem
            v-for="time in filteredVideoTimes"
            :key="time.id + 'time'"
            :id="time.id + 'time'"
            :time="time"
            :selecting="selecting"
            @toggleSelection="handleSelection(time)"
          ></TimeItem>
        </div>
        <div>
          <ClipItem
            :highlight="clip.endtime > currentTime && clip.starttime < currentTime"
            v-for="clip in ownVideoClips"
            :key="clip.id + 'clip'"
            :id="clip.id + 'clip'"
            :clip="clip"
            :selecting="selecting"
            @toggleSelection="handleSelection(clip)"
          ></ClipItem>
        </div>
        <div
          v-if="!videoTimes.length && !videoClips.length"
          class="py-10"
        >
          <div
            style="text-align: center;"
            class="mt-5 mb-4"
          >
            <div>
              {{$t('analysis.no_nothing')}}
            </div>
            <div>
              <v-btn
                @click="$emit('setState', 'clipper')"
                color="primary"
                class="mt-10"
              >
                {{$t('analysis.create_clip')}}
                <v-icon class="ml-4">mdi-format-horizontal-align-center</v-icon>
              </v-btn>
            </div>
            <v-btn
              @click="$emit('setState', 'timer')"
              color="primary"
              class="mt-3"
            >
              {{$t('analysis.create_time')}}
              <v-icon class="ml-4">mdi-timer-outline</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>


    <v-dialog scrollable max-width="1200" v-model="show_data">
      <v-card>
        <v-card-title>
          Data
        </v-card-title>
        <v-card-text>
          <DataView :clips="ownVideoClips"></DataView>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmationDialog
      :show="deleting"
      :subText="$t('analysis.are_you_sure_multiple_clip')"
      btnColor="red"
      :btnText="$t('delete')"
      :text="$t('analysis.delete_items')"
      @decline="deleting = false"
      @accept="acceptDeleting()"
    />
    <ChooseFolder
      v-if="choosing"
      :visible="choosing"
      :value="chosenFolders"
      :limit="1"
      :loading="addingToFolder"
      @input="chosenFolders = $event"
      @cancel="choosing = false; chosenFolders = []"
      @set="confirmAddToFolder()"
      :text="$t('analysis.add_to_folder')"
      />
  </v-card>
</template>










<script>
import { mapGetters, mapActions } from 'vuex'
import ClipItem from './clip/ClipItem'
import TimeItem from './time/TimeItem'
// import TagAdder from '@/components/tag/TagAdder'
import DataView from '@/components/data/DataView'
import a from '@/utils/axios/axios'
import ConfirmationDialog from '../../ConfirmationDialog.vue'
import ChooseFolder from '@/components/folder/ChooseFolder.vue'
import VideoTimes from '@/components/video/analysisBar/VideoTimes'
import TagViewsDialog from '../../tag_views/TagViewsDialog.vue'
// import ChooseFolderBtn from '@/components/folder/ChooseFolderBtn'

export default {
  components: {
    VideoTimes,
    ClipItem,
    TimeItem,
    // TagAdder,
    DataView,
    ConfirmationDialog,
    ChooseFolder,
    TagViewsDialog
    // ChooseFolderBtn
  },
  props: ['relevantClip'],
  data: () => ({
    show_own: true,
    show_lento: false,
    show_up: false,
    batchEditingMaps: false,
    batchEditingTags: false,
    newTags: [],
    handlingIndex: 0,
    chipsKey: 0,
    savingEdited: false,
    map_bases: [],
    mapPoint: [],
    settings: null,
    menu: false,
    filterTags: [],
    show_data: false,
    selecting: false,
    deleting: false,
    choosing: false,
    chosenFolders: [],
    addingToFolder: false,
    allSelected: false,
    types: [],
    canFilterTypes: true,
    ownClipsOnly: false,
    filteringByTags: false,
    tags: []
  }),
  shortcuts: {
    keydown: function (e) {
      if(!this.batchEditingTags) return this.keybinds
      if(e.code == 'Enter') {
        this.saveEditedClip()
        return false
      }
      return this.keybinds
    },
    // skipForward: function() {
    //   if(this.batchEditingTags) {
    //     this.openNextClipForEditingClips()
    //     return false
    //   }
    // }
  },
  created() {
    if(!this.currentTeamId) return
    a.get(`/maps/base/team/${this.currentTeamId}`)
      .then(e => {
        this.map_bases = e.data


        // if(e.data.length == 1) {
        //   this.$emit('startDrawing', e.data[0])
        // }
      })
      .catch(e => this.error(e))
      .finally(() => this.loading = false)
  },
  beforeDestroy() {
    this.clearSelected()
  },
  methods: {
    setShowOwn(val) {
      this.show_own = val
    },
    ...mapActions('player', [
      'openClip',
      'closeClip'
    ]),
    ...mapActions('clip', [
      'editClipTags',
      'editVideoMapPoints',
      'editClipTitle'
    ]),
    ...mapActions('noti', [
      'info',
      'error',
      'success'
    ]),
    ...mapActions('batch', [
      'addItem',
      'removeItem',
      'batchAddItems',
      'deleteSelectedItems',
      'clearItems'
    ]),
    openFilter() {
      this.clearSelected()
      this.canFilterTypes = true
      if(this.videoClips.length == 0 || this.videoTimes.length == 0) this.canFilterTypes = false
    },
    clearSelected() {
      this.selecting = false
      this.clearItems()
      this.allSelected = false;
    },
    select() {
      if(this.selecting) {
        this.clearItems()
        this.allSelected = false;
      }
      this.selecting = !this.selecting
    },
    handleSelection(item) {
      if (this.isSelected(item)) {
        this.removeItem(item);
      } else {
        this.addItem(item);
      }
    },
    selectAll() {
      if (!this.allSelected) {
        for(let clip of this.ownVideoClips) {
          this.addItem(clip)
        }
        for(let time of this.filteredVideoTimes) {
          this.addItem(time)
        }
      }
      else {
        for(let clip of this.ownVideoClips) {
          this.removeItem(clip)
        }
        for(let time of this.filteredVideoTimes) {
          this.removeItem(time)
        }
      }
    },
    isSelected(item) {
      return this.selectedItems.some(selectedItem => selectedItem.id === item.id);
    },
    handleBatchDelete() {
      this.deleting = true
    },
    acceptDeleting() {
      this.deleteSelectedItems()
      .then(() => {
        this.success(this.$t('analysis.all_deleted') + '!')
      }
      ).catch((error) => {
        this.error(error)
      }).finally(
        this.deleting = false,
        this.selecting = false,
        this.allSelected = false
      )
    },
    handleBatchFolder() {
      this.chosenFolders = []
      this.choosing = true
    },
    confirmAddToFolder() {
      const folder = this.chosenFolders && this.chosenFolders[0]
      if(!folder) return
      this.addAllToFolder(folder)
    },
    addAllToFolder(event) {
      if(event == null) return
      this.addingToFolder = true
      this.batchAddItems(event.id)
      .then(() => {
        const name = event.name || this.$t('library.library')
        this.success(this.$t('analysis.all_added') + '"' + name + '"')
      }
      ).catch((error) => {
        this.error(error)
      }).finally(() => {
        this.addingToFolder = false
        this.choosing = false
        this.selecting = false
        this.allSelected = false
        this.chosenFolders = []
      })
    },
    showData() {
      this.show_data = true
    },
    hideData() {
      this.show_data = false
    },
    handleMapInput(points) {
      points[1] ? this.mapPoint = [points[1]] : this.mapPoint = points

      this.$nextTick(() => {
        this.saveEditedPoints()
      })
    },
    itemTitle(t) {
      return `${t.title} (${t.tags.length})`
    },
    itemMapTitle(t) {
      return `${t.title} (${t.points.length})`
    },
    editTagsClicked() {
      this.batchEditingTags = !this.batchEditingTags
      if(!this.batchEditingTags) return

      this.openClip(this.leaguewideVideoClips[0])
      this.newTags = this.playingClip?.tags
      this.handlingIndex = 0
    },
    editMapsClicked() {
      this.batchEditingMaps = !this.batchEditingMaps

      if(!this.batchEditingMaps) return

      this.openClip(this.leaguewideVideoClips[0])
      this.mapPoint = this.playingClip?.points
      this.handlingIndex = 0
    },
    saveEditedClip() {
      this.savingEdited = true
      let sett = window.localStorage.getItem('tiimi-settings')
      if(sett) this.settings = JSON.parse(sett)
      let title = this.getTitle()

      let prom1 = this.editClipTags({
        tags: this.newTags.map(t => t.id),
        id: this.playingClip.id
      })

      let prom2 = this.editClipTitle({
        title,
        id: this.playingClip.id
      })

      Promise.all([prom1, prom2])
        .then(() => {
          this.info(`ok ${this.playingClip.id}`)
          this.openNextClipForEditingClips()
          this.newTags = []
        })
        .catch(e => alert(e))
        .finally(() => this.savingEdited = false )
    },
    getTitle() {
      let title = ''
      this.settings.chosenGroups.forEach((group, i) => {
        title += this.newTags.filter(tag => tag.group_id == group)[0]?.tag_name || ''
        if(i < this.settings.chosenGroups.length - 1) title += ' '
      })

      return title.trim() || 'Ei otsikkoa'
    },
    saveEditedPoints() {
      let params = {
        clip_id: this.playingClip?.id,
        points: this.mapPoint.map(t => { return {...t, map_base: this.map_bases[0]}})
      }

      this.editVideoMapPoints(params)
        .then(() => this.info('point ok'))
        .catch(e => this.error(e))
    },
    clipItemClicked() {
      if(!this.batchEditingTags) return
      let i = this.leaguewideVideoClips.findIndex(c => c.id == this.playingClip.id)
      this.openClipByIndex(i)
    },
    openClipByIndex(i) {
      if(i == undefined) return

      if(this.leaguewideVideoClips[i]) this.openClip(this.leaguewideVideoClips[i])
      else return

      this.handlingIndex = i

      this.$nextTick(() => {
        this.newTags = this.playingClip?.tags
        this.mapPoint = this.playingClip?.points
        this.$nextTick(() => {
          this.chipsKey++;
        })
      })
    },
    openClipById(id) {
      let i = this.leaguewideVideoClips.findIndex(c => c.id == id)
      this.openClipByIndex(i)
    },
    openNextClipForMaps() {

    },
    openNextClipForEditingClips() {
      let i = this.leaguewideVideoClips.findIndex(c => c.id == this.playingClip.id)

      if(i == undefined) return
      else if (i < this.leaguewideVideoClips.length - 1){
         this.openClip(this.leaguewideVideoClips[i + 1])
         this.handlingIndex = i + 1
      }
      else {
        this.openClip(this.leaguewideVideoClips[0])
        this.handlingIndex = 0
      }

      this.$nextTick(() => {
        this.newTags = this.playingClip?.tags
        this.mapPoint = this.playingClip?.points

        this.$nextTick(() => {
          this.chipsKey++;
        })
      })
    },
    openLastClipForEditingClips() {
      let i = this.leaguewideVideoClips.findIndex(c => c.id == this.playingClip.id)

      if(i == undefined) return
      else if (i > 0){
         this.openClip(this.leaguewideVideoClips[i - 1])
         this.handlingIndex = i - 1
      }
      else return

      this.$nextTick(() => {
        this.newTags = this.playingClip?.tags
        this.mapPoint = this.playingClip?.points

        this.$nextTick(() => {
          this.chipsKey++;
        })
      })
    },
    contains(tagIds, clipTagIds) {
      // jos filtterissä ei ole tageja groupissa niin klipin tagit groupissa ei vaikuta
      if(!tagIds || !tagIds.length) return true
      if(!clipTagIds || !clipTagIds.length) return false
      // jos filtterissä on groupissa tag ja clipissä ei ole tagia tästä groupista palautetaan false
      // tagIds:

      return tagIds.some(element => {
        return clipTagIds.includes(element);
      });
    },
    clipIsIn(clip) {
      let group_ids = this.filterTags.map(t => t.group_id)
      group_ids = group_ids.filter(this.onlyUnique);
      let isIn = true;
      group_ids.forEach(group => {
        let tagIds = this.filterTags.filter(tag => tag.group_id == group).map(t => t.id)
        let clipTagIds = clip.tags.filter(t => t.group_id == group).map(t => t.id)

        const hasJoin = this.contains(tagIds, clipTagIds)

        if(!hasJoin) isIn = false;
        return
      })

      return isIn
    },
    onlyUnique(value, index, array) {
      return array.indexOf(value) === index;
    },
    toggleType(event) {
        if(this.types.includes(event)) {
          this.types = this.types.filter(item => item !== event)
          return
        }
        this.types.push(event)
    },
    toggleOwnClips() {
      this.ownClipsOnly = !this.ownClipsOnly
    }
  },
  computed: {
    ...mapGetters('videos', [
      'videoClips',
      'videoTimes',
      'game_times',
      'loading_game_times',
      'loading_video_clips',
      'pesis_league_name'
    ]),
    ...mapGetters('player', [
      'playingClip',
      'currentTime',
      'playingTime'
    ]),
    ...mapGetters('user', [
      'currentTeamId',
      'user'
    ]),
    ...mapGetters('batch', [
      'selectedItems'
    ]),
    ...mapGetters('game', [
      'game_players'
    ]),
    showLentoGroup() {
      return ['msu'].includes(this.pesis_league_name)
    },
    filteredEpesisTimes() {
      const times = this.game_times.filter(t => !t.is_play)
      if(this.show_lento) return times.filter(t => t.mark_type === 'lento')
      return times
    },
    filteredEpesisTimesUp() {
      const times = this.game_times.filter(t => t.is_play)
      if(this.show_lento) return times.filter(t => t.mark_type === 'lento')
      return times
    },
    chooseButtonIndex() {
      if(!this.playingClip) return 0

      let tags = this.playingClip.tags
      let shot_made = tags.findIndex(t => t.name == 'Shot made') >= 0
      let shot_blocked = tags.findIndex(t => t.name == 'Shot blocked') >= 0

      return shot_made ? 1 : shot_blocked ? 3 : 0
    },
    ownVideoClips() {
      if (this.types.length == 0 || this.types.includes('clips')) {
        const clips = this.tags.length ? this.videoClips.filter(c => c.tags.map(t => t.id).some(t => this.tags.map(t => t.id).includes(t))) : this.videoClips

        if(this.ownClipsOnly) return clips.filter(v => !v.leaguewide).filter(c => this.clipIsIn(c) && c.creator == this.user.email)
        return clips.filter(v => !v.leaguewide).filter(c => this.clipIsIn(c))
      }
      return []
    },
    filteredVideoTimes() {
      if (this.types.length == 0 || this.types.includes('times')) {
        const times = this.tags.length ? this.videoTimes.filter(c => c.tags.map(t => t.id).some(t => this.tags.map(t => t.id).includes(t))) : this.videoTimes

        if(this.ownClipsOnly) return times.filter(v => !v.leaguewide).filter(t => this.clipIsIn(t) && t.creator == this.user.email)
        return times.filter(v => !v.leaguewide).filter(t => this.clipIsIn(t))
      }
      return []
    },
    leaguewideVideoClips() {
      return this.videoClips.filter(v => v.leaguewide)
    },
    isAnalysis() {
      return this.$route.path.includes('analysis')
    },
    // filterByTags(tags) {

    // }
  }
}
</script>

<style lang="scss" scoped>
  .clips {
    overflow-y: scroll;
    flex-grow: 1;
    max-height: calc(100vh - 200px);
  }
  .clips-mobile {
    overflow-y: scroll;
    flex-grow: 1;
    max-height: calc(100vh - 336px);
  }

  input[type="checkbox"] {
  transform:scale(1.3, 1.3);
  }
</style>